<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>
        
        <div class="row">
            <div class="col-sm-12 form-group">
                <label>Nome</label>
                <div class="input-group">
                    <input type="text" class="form-control" :value="dados.pacienteNome" disabled>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" id="atualiza-dados-alta" @click="refreshTokenCallMethod('censo_atualizaDadosCns', 'atualizaDadosCns')">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Atualizar Dados
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label>CNS</label>
                <input type="text" class="form-control" :value="dados.pacienteCns" disabled>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 form-group">
                <label>AIH</label>
                <input v-if="!dados.aih" type="text" class="form-control" value="Nenhuma AIH" disabled>
               
                <div class="input-group" v-if="dados.aih">
                    <input type="text" class="form-control" :value="dados.aih[0].numeroAih + ' - ' + dados.aih[0].statusAih" disabled>
                    <div class="input-group-append" v-if="dados.aih.length > 1">
                        <button class="btn btn-outline-secondary" type="button" @click="verMaisAih = !verMaisAih">ver mais +</button>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div class="bordas" v-if="dados.aih && verMaisAih">
                <div class="row" v-for="(aih, index) in dados.aih" :key="index">
                    <div class="form-group col" v-if="index !== 0">
                        <label>AIH {{index + 1}}</label>
                        <input type="text" class="form-control" :value="aih.numeroAih + ' - ' + aih.statusAih" disabled>
                    </div>
                </div>
            </div>
        </transition>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label>Data de Nascimento</label>
                <input type="text" class="form-control" :value="dados.pacienteDataNascimento" disabled>
            </div>
            <div class="col-sm-2 form-group">
                 <label>Idade</label>
                <input type="text" class="form-control" :value="dados.pacienteIdade" disabled>
            </div>
            <div class="col-sm-4 form-group">
                <label>Sexo</label>
                <select type="text" class="form-control" :value="dados.pacienteSexo"  disabled>
                    <option value="1">Masculino</option>
                    <option value="2">Feminino</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label>Data/Hora Admissão</label>
                <input type="text" class="form-control" :value="dados.DataHoraInternacao" disabled>
            </div>
            <div class="col-sm-6 form-group">
                <label>Data/Hora Admissão Leito</label>
                <input type="text" class="form-control" :value="dados.dataHoraInternacaoLeito" disabled>
            </div>
        </div>

        <b-alert variant="warning" show>
            Caso você queira realizar <strong>transferência de leito</strong>, 
            não deve registrar a saída, mas sim usar a opção <strong>transferência interna</strong>
        </b-alert>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label>Motivo da saída</label>
                <select class="form-control" v-model="motivo">
                    <option value="" selected disabled>Selecione</option>
                    <option value="1">Alta Médica</option>
                    <option value="2">Transferência Interna</option>
                    <option value="3">Regulado</option>
                    <option value="4">Óbito</option>
                    <option value="5">Fuga/Evasão</option>
                    <option value="6">Alta a Pedido</option>
                </select>
                <small v-if="motivo == ''" class="text-danger">preenchimento obrigatório</small>
            </div>

            <div class="col-sm-6 form-group" v-if="motivo === '3'">
                <label>Se Regulado, qual o destino?</label>
                <select class="form-control" v-model="reguladoDestino" v-if="selects">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selects.reguladoDestino" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
                <small v-if="reguladoDestino == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>


        <div class="row">
            <div class="col-sm-6 form-group">
                <label for="data-picker">Data da Saída</label>
                <datepicker
                    v-model="data_alta_semformatacao"
                    :format="formatoData"
                    :disabled="dateDisabled"
                    language="pt-br"
                    id="data-picker"
                    calendar-button
                    calendar-button-icon="fa fa-calendar"
                    >
                </datepicker>
            </div>

            <div class="col-sm-6 form-group">
                <label>Hora da Saída</label>
                <input class="form-control" type="time" v-model="hora">
                <small v-if="hora == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>

        <button type="button" class="btn btn-primary" :disabled="desabilitaBtn || (unidadeSelecionada.cnes != usuario.cnes)" @click="validaSessao('realizarAlta')">Realizar Saída</button>

        <b-alert variant="danger" :show="unidadeSelecionada.cnes != usuario.cnes" class="mt-4">
            Unidade divergente da que está logado
        </b-alert>

        <b-alert variant="danger" :show="errorAlta ? true : false" class="mt-4">
            Favor preencher todos os campos solicitados
        </b-alert>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { captcha } from '../../../shared/mixins/captcha'
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    mixins: [
        captcha,
        validaSessao
    ],
    components: {
        Datepicker
    },
    props: {
        dados: Object,
    },
    mounted () {
        let hora = new Date().getHours()
        let min = new Date().getMinutes()
        if (hora < 10) hora = '0' + hora
        if (min < 10) min = '0' + min
        
        this.hora = hora + ':' +  min

        this.verificaNomeSocial();             

        this.desabilitaDatas()
    },
    computed: {
        selects () {
            return this.$store.getters['leitos/getOpcoesSelect']
        },
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        token_captcha () {
            return this.$store.getters['sessao/getCaptcha']
        },
        usuario () {
            return this.$store.getters['sessao/getUsuario']
        }
    },
    data () {
        return {
            formatoData: 'dd/MM/yyyy',
            data_alta_semformatacao: new Date(),
            dateDisabled: {
                ranges: [
                    {
                        from: new Date(1990, 11, 25),
                        to: new Date(1990, 11, 26)
                    },
                    {
                        from: new Date(),
                        to: new Date(2040, 2, 25)
                    }
                ]
            },
            hora: '',
            motivo: '',
            reguladoDestino: '',

            errorAlta: false,
            verMaisAih: false,
            desabilitaBtn: false
        }
    },
    methods: {
        verificaNomeSocial () {
            try {
                if (this.dados.pacienteNomeSocial != null && this.dados.pacienteNomeSocial != '') {
                    this.dados.pacienteNome = this.dados.pacienteNomeSocial
                }
            }
            catch (e) {
                console.error(e)
            }
        },        
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        desabilitaDatas () {
            if (this.dados.dataHoraUltimaMovimentacao !== null && this.dados.dataHoraUltimaMovimentacao !== '') {
                let ultimaMovimentacao = this.dados.dataHoraUltimaMovimentacao
                let dia = parseInt(ultimaMovimentacao.substr(0,2))
                let mes = parseInt(ultimaMovimentacao.substr(3,2)) - 1
                let ano = parseInt(ultimaMovimentacao.substr(6,4))

                this.dateDisabled.ranges[0]['to'] = new Date(ano, mes,dia)
            }
        },
        atualizaDadosCns () {
            this.$store.dispatch('altahospitalar/atualizaDadosCns', {cns: this.dados.pacienteCns, captcha: this.token_captcha, id: this.dados.leitoId, pacienteId: this.dados.pacienteId})
                .then(() => {
                    this.$emit('fechar')
                })
        },
        realizarAlta () {
            this.desabilitaBtn = true
            if (this.motivo == '' || this.hora.length < 5) {
                this.errorAlta = true
                this.desabilitaBtn = false
                setTimeout(() => { this.errorAlta = false }, 4000)
                return
            }

            let datahora = this.formatadata(this.data_alta_semformatacao) + ' ' + this.hora

            let dados = {
                cns: this.dados.pacienteCns,
                dataHoraAlta: datahora,
                motivoAlta: this.motivo,
                idUnidadeDestino: this.reguladoDestino
            }

            this.$emit('alta', dados)
        }
    }
}
</script>

<style>
.fade-enter-active{
  transition: opacity .5s;
}

.fade-enter{
  opacity: 0;
}
</style>